module.exports = __webpack_public_path__ + "static/media/24.74815772.jpeg";